import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corporate-home',
  templateUrl: './corporate-home.component.html',
  styleUrls: ['./corporate-home.component.scss']
})
export class CorporateHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
